<script>
import Audio from '@components/Audio'

export default {
  components: {
    Audio,
  },
  inheritAttrs: false,
  props: {
    // Public: Whether to display the file duration when paused or elapsed time while playing
    showDuration: { type: Boolean, default: false },
    // Public: Whether to allow mp3 files to be uploaded
    allowMp3: { type: Boolean, default: false },
    // Public: Whether to allow flac files to be uploaded
    allowFlac: { type: Boolean, default: false },
    // Public: Custom accept string for additional audio formats
    accept: { type: String, default: null },
  },
  computed: {
    allowedFileFormats () {
      if (this.accept) {
        return this.accept
      }

      let formats = 'audio/wav'
      if (this.allowMp3) formats += ', audio/mp3, audio/mpeg'
      if (this.allowFlac) formats += ', audio/flac'

      return formats
    },
  },
}
</script>

<template>
  <FileInput
    :accept="allowedFileFormats"
    class="audio-input"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot="labelExtras">
      <slot name="labelExtras"/>
    </template>
    <template slot="file" slot-scope="{ file }">
      <Audio :file="file" :showDuration="showDuration"/>
    </template>
    <template slot="fileExtras" slot-scope="slotScope">
      <slot name="fileExtras" v-bind="slotScope"/>
    </template>
  </FileInput>
</template>

<style lang="scss" scoped>

</style>
